import { Col, Divider, Input, Pagination, Row } from 'antd';
import { commonApi } from 'api/commonApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import AddEditFormInverter from 'components/Common/Modal/AddEditFormInverter';
import { inverterActions, selectInverterList } from 'features/Inverter/inverterSlice';
import { selectPlantInfo } from 'features/Plant/plantSlice';
import { objectDevice } from 'models';
import * as React from 'react';
import { FaSearch } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import InverterInfo from '../InverterInfo/InverterInfo';
import ItemInverterList from '../ItemInverterList/ItemInverterList';
import style from './Devices.module.scss';
export interface DevicesProps {}

export default function Devices(props: DevicesProps) {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [pagePlant, setPagePlant] = React.useState<number>(0);
  const [isShowDevicesDetail, setIsShowDevicesDetail] = React.useState(true);
  const itemPlant = useAppSelector(selectPlantInfo);
  const dispatch = useAppDispatch();
  const inverterList = useAppSelector(selectInverterList);
  const isEvent: boolean = false;
  const [SensorType, setSensorType] = React.useState<objectDevice[]>();

  // React.useEffect(() => {
  //   if (itemPlant) {
  //     (async () => {
  //       const res = await commonApi.fetchDeviceProfile({
  //         text_search: 'Inverter',
  //         _limit: 600,
  //         _page: 0,
  //       });
  //       setSensorType(res.data);
  //       dispatch(
  //         inverterActions.fetchInverterList({
  //           type: 'inverter-list?plant_id',
  //           id: itemPlant.id,
  //           page: pagePlant,
  //           page_size: 10,
  //         })
  //       );
  //     })();
  //   }
  // }, []);
  React.useEffect(() => {
    if (itemPlant) {
      (async () => {
        const res = await commonApi.fetchDeviceProfile({
          text_search: 'Inverter',
          _limit: 600,
          _page: 0,
        });
        setSensorType(res.data);
        dispatch(
          inverterActions.fetchInverterList({
            type: 'inverter-list?plant_id',
            id: itemPlant.id,
            page: pagePlant,
            page_size: 10,
          })
        );
      })();
    }
  }, [itemPlant]);

  const onChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    console.log('🚀 ~ file: listOfGateWay.jsx ~ line 28 ~ onChangeValue ~ val', val);
  };

  const onChangePage = (page: number) => {
    setPagePlant(page - 1);
    if (itemPlant) {
      dispatch(
        inverterActions.fetchInverterList({
          type: 'inverter-list?plant_id',
          id: itemPlant.id,
          page: page - 1,
          page_size: 10,
        })
      );
    }
  };

  return (
    <>
      {isShowDevicesDetail ? (
        <Row className={style.root}>
          <Row className={style.header_info}>
            <Divider orientation="left" plain style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Devices
            </Divider>
          </Row>
          <Row className={style.main}>
            <Row className={style.header_main}>
              <Input
                onChange={onChangeValue}
                size="large"
                placeholder="Search by label"
                prefix={<FaSearch />}
                className={style.search_header}
              />
              <FiPlus
                onClick={() => {
                  setIsModalVisible(!isModalVisible);
                }}
                className={style.btn_create}
                size={20}
              />
            </Row>
            <div className={style.main_table}>
              <Row className={style.header_table}>
                <Col className={style.item_header} span={4}>
                  CODE
                </Col>
                <Col className={style.item_header} span={4}>
                  LABEL
                </Col>
                <Col className={style.item_header} span={6}>
                  MODEL
                </Col>
                <Col className={style.item_header} span={4}>
                  STATUS
                </Col>
                <Col className={style.item_header} span={6}>
                  LAST ACTIVITY TIME
                </Col>
              </Row>
              <div className={style.content_table} id={style.style_4}>
                {inverterList?.data.map((item, index) => {
                  return (
                    <ItemInverterList
                      key={item.id}
                      item={item}
                      setIsShowDevicesDetail={setIsShowDevicesDetail}
                    />
                  );
                })}
              </div>
            </div>
          </Row>
          <Row className={style.footer_list}>
            {inverterList?.total_elements ? (
              <Pagination
                size="small"
                onChange={onChangePage}
                defaultPageSize={10}
                defaultCurrent={1}
                total={inverterList?.total_elements}
                showSizeChanger={false}
                showQuickJumper={false}
              />
            ) : null}
          </Row>
        </Row>
      ) : (
        <InverterInfo
          isShowDevicesDetail={isShowDevicesDetail}
          setIsShowDevicesDetail={setIsShowDevicesDetail}
          // setGatewayList={setGatewayList}
        />
      )}
      {SensorType && (
        <AddEditFormInverter
          SensorType={SensorType}
          isEvent={isEvent}
          itemInverter={undefined}
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
        />
      )}
    </>
  );
}
